import { Controller } from "@hotwired/stimulus";

// Base class for initialize Yandex Map
// The class is abstract, everyone inherits from it (mini-app, home, detailing)

// Connects to data-controller="base-addresses"
export default class extends Controller {
  PLACEMARK_URL = RAILS_ASSET_URL("placemark.svg");

  static targets = ["map"];

  static values = {
    branches: Array,
  };

  connect() {
    this.#initMap();
  }

  // Abstracts methods
  placemarkCallback(selectedBranch) {
    throw new Error("Function 'placemarkCallback' must be implemented!");
  }

  buildPlacemarkHTML(branch) {
    throw new Error("Function 'buildPlacemarkElement' must be implemented!");
  }

  // Private methods
  async #initMap() {
    await ymaps3.ready;
    if (!this.hasMapTarget) return;
    this.ymap = new ymaps3.YMap(
      this.mapTarget,
      {
        location: {
          center: this.branchesValue[0].data.xy.reverse(),
          zoom: 11,
        },
      },
      [
        new ymaps3.YMapDefaultSchemeLayer({}),
        new ymaps3.YMapDefaultFeaturesLayer({}),
      ],
    );
    this.#setCenterForMap();
    this.branchesValue.forEach(this.#putPlacemarkOnMap.bind(this));
  }

  #setCenterForMap() {
    // If you need display several points on map
    if (this.branchesValue.length > 1) {
      this.ymap.setLocation({
        bounds: [
          this.branchesValue[0].data.xy.reverse(),
          this.branchesValue[2].data.xy.reverse(),
        ],
      });
    }
    this.ymap.setLocation({
      zoom: 11,
    });
  }

  #putPlacemarkOnMap(branch) {
    const marker = new ymaps3.YMapMarker(
      {
        coordinates: branch.data.xy.reverse(),
      },
      this.#createPlacemark(branch),
    );
    this.ymap.addChild(marker);
  }

  #createPlacemark(branch) {
    const placemarkElement = this.buildPlacemarkHTML(branch);
    placemarkElement.addEventListener(
      "click",
      this.placemarkCallback.bind(this, branch),
    );
    return placemarkElement;
  }
}
